import { AdminSettings } from '../types';
import { readStorage, writeStorage } from './adminStorage';

const STORAGE_KEY = 'coh-admin-settings';

export const defaultAdminSettings: AdminSettings = {
  appName: 'Circle of Humanity',
  supportEmail: 'support@circleofhumanity.app',
  defaultCauseCategory: 'Emergency Relief',
  notificationsEnabled: true,
  approvalRequiredForPublishing: true,
  featureFlags: {
    featuredCauses: true,
    impactStories: true,
    analyticsExports: true,
    adminAuditFeed: true,
  },
  adminPreferences: {
    compactTables: false,
    showQuickActions: true,
  },
};

export const AdminSettingsService = {
  async getSettings(): Promise<AdminSettings> {
    return readStorage<AdminSettings>(STORAGE_KEY, defaultAdminSettings);
  },

  async saveSettings(settings: AdminSettings): Promise<AdminSettings> {
    writeStorage(STORAGE_KEY, settings);
    return settings;
  },
};
